mutation ReissueContractPaymentInvoice($id: ID!, $reason: String!) {
  reissueContractPaymentInvoice(id: $id, reason: $reason) {
    id
    status
    expired
    invoiceUrl
    invoice {
      number
      issuedAt
      sentAt
      sentTo
      previousNumbers {
        number
        issuedAt
        reason
      }
    }
  }
}
